export default {"src":"/_next/static/media/ico6.99275d15.svg","height":29,"width":26,"blurWidth":0,"blurHeight":0};